@if (loggedUserService.loggedUser) {
  <app-left-nav></app-left-nav>
}

<div [class.innova-app]="loggedUserService.loggedUser">
  @if (loggedUserService.loggedUser) {
    <app-header></app-header>
  }

  <main>
    <app-loader></app-loader>
    <app-map-context-menu />
    <router-outlet></router-outlet>
  </main>
</div>
